import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import {
  TextContainer,
  DisplayText,
  Modal,
  Button
} from '@superops/ui-design-system';
import { Delete } from '@styled-icons/material/Delete';
import { injectIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

const DeleteIcon = styled(Delete)`
  height: 20px;
  color: black;
  width: 20px;
`;

function ConfirmationModal(props) {
  const [active, setActive] = useState(false);
  const {
    intl,
    modalActivator,
    confirmText,
    variant = 'default',
    sectioned = true,
    hideFooterBorder = false,
    showCloseButton = true
  } = props;
  const handleChange = useCallback(() => setActive(!active), [active]);

  const handleConfirmation = useCallback(() => {
    if (props.handleConfirmation) {
      props.handleConfirmation();
    }
    handleChange();
  });

  return (
    <div>
      {modalActivator ? (
        <div onClick={handleChange} id={props.id}>
          {modalActivator}
        </div>
      ) : (
        <Button
          onClick={handleChange}
          id={props.id}
          destructive={props?.destructive}
          plain={props?.plain}
        >
          {props?.noIcon ? 'Delete' : <DeleteIcon />}
        </Button>
      )}
      <Modal
        open={active}
        onClose={handleChange}
        title={props.title || 'Confirmation'}
        variant={variant}
        hideFooterBorder={hideFooterBorder}
        showCloseButton={showCloseButton}
        primaryAction={{
          content: confirmText || getTranslatedText(intl, 'common.confirm'),
          onAction: handleConfirmation
        }}
        secondaryActions={[
          {
            content: getTranslatedText(intl, 'common.cancel'),
            onAction: handleChange,
            plainSecondary: true
          }
        ]}
        zIndex={1000}
      >
        {sectioned ? (
          <Modal.Section>
            <TextContainer>
              {props.template ? (
                props.template
              ) : (
                <p>{props.description || 'Are you sure?'}</p>
              )}
            </TextContainer>
          </Modal.Section>
        ) : (
          <TextContainer>
            {props.template ? (
              props.template
            ) : (
              <DisplayText element="p" size="large">
                {props.description || 'Are you sure?'}
              </DisplayText>
            )}
          </TextContainer>
        )}
      </Modal>
    </div>
  );
}

export default injectIntl(ConfirmationModal);
